export default "__VITE_ASSET__CD5Y14Yy__"